export const BlogData  = [
    {
        id:1,
        img:require("./DataBlog/imgblog1.jpg"),
        date:"05 December 2019",
        title:"Lorem Ipsum Dolo",
        paragraph:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt, vitae modi ex alias, quidem quisquam id reiciendis perferendis cum molestias, nulla voluptatibus dolor aperiam harum quasi voluptas deserunt quam ipsum!",
        partBlog:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt, vitae modi ex alias, quidem quisquam id reiciendis perferendis cum molestias, nulla"
    },
    {
        id:2,
        img:require("./DataBlog/imgblog3.jpg"),    
        date:"05 December 2019",
        title:"Lorem Ipsum Dolo",
        paragraph:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt, vitae modi ex alias, quidem quisquam id reiciendis perferendis cum molestias, nulla voluptatibus dolor aperiam harum quasi voluptas deserunt quam ipsum!",
        partBlog:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt, vitae modi ex alias, quidem quisquam id reiciendis perferendis cum molestias, nulla"
    },
    {
        id:3,
        img:require("./DataBlog/imgblog3.jpg"),
        date:"05 December 2019",
        title:"Lorem Ipsum Dolo",
        paragraph:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt, vitae modi ex alias, quidem quisquam id reiciendis perferendis cum molestias, nulla voluptatibus dolor aperiam harum quasi voluptas deserunt quam ipsum!",
        partBlog:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt, vitae modi ex alias, quidem quisquam id reiciendis perferendis cum molestias, nulla"
    },
    {
        id:4,
        img:require("./DataBlog/imgblog4.jpg"),
        date:"05 December 2019",
        title:"Lorem Ipsum Dolo",
        paragraph:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt, vitae modi ex alias, quidem quisquam id reiciendis perferendis cum molestias, nulla voluptatibus dolor aperiam harum quasi voluptas deserunt quam ipsum!",
        partBlog:"Lorem ipsum dolor sit amet consectetur adipisicing elit"
    },
    {
        id:5,
        img:require("./DataBlog/imgblog1.jpg"),
        date:"05 December 2019",
        title:"Lorem Ipsum Dolo",
        paragraph:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt, vitae modi ex alias, quidem quisquam id reiciendis perferendis cum molestias, nulla voluptatibus dolor aperiam harum quasi voluptas deserunt quam ipsum!",
        partBlog:"Lorem ipsum dolor sit amet consectetur adipisicing elit"
    },

]